class CookieManager {

    get(name: string) {
        let matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : null;
    }

    set(name: string, value: string, day: number) {

        let options = {
            path: '/',
            expires: null
            // при необходимости добавьте другие значения по умолчанию
           // ...options
        };

        if (day) {
            const date = new Date();
            date.setTime(date.getTime() + (day * 24 * 60 * 60 * 1000));
            options.expires = date.toUTCString();
        }

        let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

        for (let optionKey in options) {
            updatedCookie += "; " + optionKey;
            let optionValue = options[optionKey];
            if (optionValue !== true) {
                updatedCookie += "=" + optionValue;
            }
        }

        document.cookie = updatedCookie;
    }
}

const cookieManager = new CookieManager();

window['cookieManager'] = cookieManager;

export {cookieManager};
